import './App.css';
import Layout from './layout';

function App() {
  return (
    <>
      <Layout />
    </>
  );
}

export default App;
